import React from 'react';

const YellowWarningCircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      fill="none"
      viewBox="0 0 44 44"
    >
      <rect width="44" height="44" fill="#FECC1E" opacity=".1" rx="22" />
      <path
        stroke="#FECD1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22.001 23.1v-3.7"
      />
      <path
        fill="#323232"
        d="M22.001 26c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4Z"
      />
      <path
        stroke="#FECD1E"
        strokeWidth="1.5"
        d="M22.001 26c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4"
      />
      <path
        stroke="#FECD1E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m24 14.1 7.7 13.4c.9 1.6-.2 3.5-2 3.5H14.4c-1.8 0-2.9-1.9-2-3.5l7.7-13.4c.8-1.5 3-1.5 3.9 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default YellowWarningCircleIcon;
